import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { serverService, PublicServer } from '@/lib/services/server.service';
import { useStore } from '@/contexts/StoreContext';
import { SEM_SERVIDOR, ehLojaDigital } from '@/lib/loja-digital';

export function useServers(storeId: string | undefined) {
  const [servers, setServers] = useState<PublicServer[]>([]);
  const [loading, setLoading] = useState(true);
  const { store } = useStore();
  const { t } = useTranslation();
  const digital = ehLojaDigital(store);
  const nomeDoCatalogo = t('store.digital.catalog');

  useEffect(() => {
    // Loja digital: um "servidor" só, o catálogo inteiro (ver lib/loja-digital).
    if (digital) {
      setServers([{ id: SEM_SERVIDOR, name: nomeDoCatalogo, gameType: 'DIGITAL', status: 'active', imageUrl: null }]);
      setLoading(false);
      return;
    }
    if (!storeId) {
      setServers([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    serverService
      .listByStore(storeId)
      .then(setServers)
      .catch(() => setServers([]))
      .finally(() => setLoading(false));
  }, [storeId, digital, nomeDoCatalogo]);

  return { servers, loading };
}
